import React, { useEffect, useState } from 'react';
import styles from './ShareHoldingPattern.module.scss';
import { fetchShareholdingPatternData } from '../../../../../../store/dashboard/overview/actions';
import { useAppDispatch } from '../../../../../../app/hooks';
import { isEmpty } from 'lodash';

import { downloadIconDataRoomHovered } from '../../../../../../assets/hostedassets';
import { downloadFile } from '../../../../../Company/UploadJourney/components/UploadCard/utils/api/helpers';
import LoadingSpinner from '../../../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import { toast } from 'react-toastify';
import A4Page from '../../../../../AicaPDFReport/A4Page/A4Page';
import { REPORT_SECTION_NAMES } from '../../../../../../store/pdfReport/pdfReport_constants';
import { formatFinancialDate } from '../../../../../../utils/dateUtils';
import { DATA_FETCH_STATUS } from '../../../../../../store/dashboard/constants';
import AskAicaQuestionBadge from '../../../../../../common/AskAicaQuestionBadge/AskAicaQuestionBadge';

interface ShareHoldingPatternProps {
    isPDFReport?: boolean;
    mcaDocApiData?: any;
    tabName?: string;
}
interface ShareholdingMetadata {
    financialEndDate?: string;
    mnemosyneDocId?: string;
}

const ShareHoldingPattern: React.FC<ShareHoldingPatternProps> = ({
    isPDFReport = false,
    mcaDocApiData = {} as any,
    tabName = 'overview',
}) => {
    const dispatch = useAppDispatch();
    const [rowData, setRowData] = useState([]);
    const [metaData, setMetaData] = useState<ShareholdingMetadata>({});
    const [downloadShareHoldingData, setDownloadShareHoldingData] = useState(false);

    useEffect(() => {
        fetchShareholdingData();
    }, [tabName]);

    const fetchShareholdingData = () => {
        dispatch(
            fetchShareholdingPatternData({
                graphNames: ['shareholdingPattern'], // @todo: change this hardcoding to store value in future. Since the credit beaureu config is hardcoded in Investor Saga Line No. 30.
                tabName,
                startDate: '',
                endDate: '',
                tenure: 'Monthly',
                onSuccess: (res) => {
                    setRowData(res?.shareholdingPattern?.plots?.[0]?.plotValues ?? []);
                    setMetaData(res?.shareholdingPattern?.metadata ?? {});
                },
            }),
        );
    };

    const handleDownload = async (docId: number) => {
        setDownloadShareHoldingData(true);
        try {
            await downloadFile(docId);
        } catch (error: unknown) {
            toast.error('Error downloading file.');
        } finally {
            setDownloadShareHoldingData(false);
        }
    };

    if (!rowData?.length) {
        if (isPDFReport) return <></>;
        return (
            <div className={styles.shareholdingPattern}>
                <div className={styles.emptyHeader}>
                    <h2 className={styles.heading}>Shareholding Pattern</h2>
                    <div className={styles.emptyRight}>
                        <span className={styles.noMcaData}>No Data Available on MCA</span>
                    </div>
                </div>
            </div>
        );
    }
    const render = (
        <div className={styles.shareholdingPattern}>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h2 className={styles.heading}>Shareholding Pattern</h2>
                    {mcaDocApiData?.reportStatus === DATA_FETCH_STATUS.PROCESSING && mcaDocApiData?.isFetching && (
                        <div className={styles.loaderMessage}>
                            <LoadingSpinner color="#6021b3" height="15px" />
                            <span>Fetching latest data from MCA (takes upto 24 hours)</span>
                        </div>
                    )}
                </div>
                <div className={styles.headerRight}>
                    {(metaData?.financialEndDate || metaData?.mnemosyneDocId) && (
                        <>
                            {metaData?.financialEndDate && (
                                <span className={styles.date}>{formatFinancialDate(metaData.financialEndDate)}</span>
                            )}
                            {metaData?.mnemosyneDocId && (
                                <div className={styles.downloadWrapper} onClick={() => handleDownload(Number(metaData?.mnemosyneDocId))}>
                                    {downloadShareHoldingData ? (
                                        <LoadingSpinner color="purple" height="15px" />
                                    ) : (
                                        <img src={downloadIconDataRoomHovered} alt="" />
                                    )}
                                    <span className={styles.downloadText}>Download Details</span>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.contentBody}>
                    <div className={styles.table}>
                        <div className={styles.tableHeader}>
                            <div>Name</div>
                            <div>Type</div>
                            <div>Shareholding(%)</div>
                        </div>
                        <div className={styles.tableBody}>
                            {isEmpty(rowData) ? (
                                <div className={styles.tableRow}>
                                    <div className={styles.noData}>No data available</div>
                                </div>
                            ) : (
                                rowData.map((row: any, index) => (
                                    <div key={index} className={styles.tableRow}>
                                        <div>{row.rowVal ?? '-'}</div>
                                        <div>{row.rowVal2 ?? '-'}</div>
                                        <div>{row.rowVal3 ?? '-'}</div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    if (isPDFReport) return <A4Page sectionName={REPORT_SECTION_NAMES.SHAREHOLDING_PATTERN}>{render}</A4Page>;
    return render;
};

export default ShareHoldingPattern;
